<template lang="pug">
global-form-group(
    :title="field.title"
    :field-name="field.name"
    :show-label="showLabel"
    :edit-toggle="true"
)
    div.slotInput(:class="editable ? '' : 'disable-edit'")
        input(@input="changeInput" v-model="content")
        div.desc {{ field.description }}

</template>

<script>
import GlobalFormGroup from "../../GlobalFormGroup";
import {excludeSpecial} from "@/commons/TextParse";

export default {
    name: "NseText",
    components: {GlobalFormGroup},
    props: {
        field: {},
        selected: {},
        showLabel: {
            type: Boolean,
            default: true
        },
        selected_full: {
            type: Object,
            default() {
                return {}
            }
        }
    },

    data() {
        return {
            timeout_input: false,
            content_tmp: '',
        }
    },

    computed: {
        content: {
            get() {
                return this.selected ? this.selected.value : ''
            },
            set(nv) {
                this.content_tmp = nv;
            }
        },

        editable() {
            return this.store.value[`editable_${this.field.name}`];
        }
    },

    methods: {
        changeInput() {
            var self = this;

            if (this.timeout_input) {
                clearTimeout(this.timeout_input);
                this.timeout_input = false;
            }

            this.timeout_input = setTimeout(() => {
                self.changeSelect();
            }, 400);
        },


        changeSelect() {
            var self = this;
            var str = excludeSpecial(self.content_tmp)
            var o = Object.assign({}, this.field, {
                value: str
            });
            this.$emit('select', o);
        }
    }
}
</script>


<style lang="scss">

</style>
